import React from "react";
import { Bar } from "react-chartjs-2"
import { totalMonthlyTransaction, filterTransaction } from "../../../../api/financial";
import Button from "../../../../_components/Button";
import Text from "../../../../_components/Text";
import translations from "../languages"
import { formatCurrencyValue } from "../../../../utils";
import AppContext from "../../context";
import Dialog from "../../../Fiscal/NFe/Issuer/Dialog";
import { startTrial } from "../../../../api/financial";
import { formatDate } from "../../../../utils";
import Toast from "../../../../_components/Toast";
import TableData from "../../../../_components/TableData";

const defaultMonthLabels = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"]

const StatusChoices = {
    1: <i style={{ color: "red" }} className="fas fa-circle" />,
    2: <i style={{ color: "green" }} className="fas fa-circle" />,
    3: "Cancelado",
    4: "Vencido",
    5: "Renegociado"
}

export default (props) => {
    const ref = React.useRef();
    const context = React.useContext(AppContext)

    const [financialData, setFinancialData] = React.useState({ pay_in: {}, pay_out: {} })
    const [financialAllowed, setFinancialAllowed] = React.useState(false)
    const [startDate, setStartDate] = React.useState('')
    const [endDate, setEndDate] = React.useState('')
    const [totalPayInData, setTotalPayInData] = React.useState({ to_receive: 0, received: 0 })
    const [totalPayOutData, setTotalPayOutData] = React.useState({ to_pay: 0, paid: 0 })
    const [language, setLanguage] = React.useState('pt')
    const [ShowNotAllowed, setShowNotAllowed] = React.useState(false)
    const [data, setData] = React.useState({});
    const [toast, setToast] = React.useState({
        message: "",
        show: false,
        type: "erro",
    });
    const [show, setShow] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [lastPayInTransactions, setlastPayInTransactions] = React.useState([])
    const [lastPayOutTransactions, setlastPayOutTransactions] = React.useState([])



    function handleClick() {
        setLoading(true);
        startTrial()
            .then((resp) => {
                setData({
                    startDate: formatDate(resp["activated!"].start),
                    endDate: formatDate(resp["activated!"].end),
                });
                setShow(true);
                setInterval(() => {
                    window.location.href = "financial/pay-out";
                }, 10000);
            })
            .catch((error) => {
                if (error === "module_already_activate") {
                    setToast({
                        show: true,
                        message: "Já foi solicitado o teste grátis!",
                    });
                } else {
                    setLoading(false);
                }
                setShow(false);
            });
    }

    const handleChangeLanguage = (event) => {
        setLanguage(event.target.value)
    }

    const international = translations[language]

    function loadFinancialChartData(params, labels = defaultMonthLabels) {

        totalMonthlyTransaction({ ...params, pay_out: true, pay_in: true }).then(resp => {
            console.log(resp)
            const newData = {
                labels,
                datasets: [
                    {
                        label: 'Total Pago (R$)',
                        data: resp.map(month => month.pay_out.paid),
                        backgroundColor: '#27ae60'
                    },
                    {
                        label: 'Total Recebido (R$)',
                        data: resp.map(month => month.pay_in.received),
                        backgroundColor: '#2980b9'
                    },
                    {
                        label: 'A Pagar (R$)',
                        data: resp.map(month => month.pay_out.to_pay),
                        backgroundColor: '#e74c3c'
                    },
                    {
                        label: 'A Receber (R$)',
                        data: resp.map(month => month.pay_in.to_receive),
                        backgroundColor: '#1abc9c'
                    }
                ]
            };
            setFinancialData(newData);
        })
    }

    async function _getPayInTransacations(params = { type: 1, end_count: 5 }) {
        await filterTransaction(params)
            .then(result => {
                let to_receive = 0
                let received = 0

                result = result.reverse().map((mappedItem, index) => {

                    if (mappedItem.status == 1) {
                        to_receive += mappedItem.value
                    }

                    if (mappedItem.status == 2) { received += mappedItem.paid_value }

                    return {
                        ...mappedItem,
                        idx: index + 1,
                        value: formatCurrencyValue(mappedItem.value),
                        due_date: formatDate(mappedItem.due_date, false),
                        description: mappedItem.description,
                        status: <text >{StatusChoices[mappedItem.status]}</text>,

                    }
                })
                setlastPayInTransactions(result)
                setTotalPayInData({ to_receive, received })
            })
    }

    async function _getPayOutTransacations(params = { type: 2, end_count: 10 }) {
        await filterTransaction(params)
            .then(result => {
                let to_pay = 0
                let paid = 0
                result = result.reverse().map((mappedItem, index) => {

                    if (mappedItem.status == 1) {
                        to_pay += mappedItem.value
                    }
                    if (mappedItem.status == 2) { paid += mappedItem.paid_value }
                      
                    return {
                        ...mappedItem,
                        idx: index + 1,
                        value: formatCurrencyValue(mappedItem.value),
                        due_date: formatDate(mappedItem.due_date, false),
                        description: mappedItem.description,
                        status: <text >{StatusChoices[mappedItem.status]}</text>,

                    }
                })
                setlastPayOutTransactions(result)
                setTotalPayOutData({ to_pay, paid })

            })
    }

    function init() {
        _getPayInTransacations().catch(e => {

            if (e.status == 403) {

                setShowNotAllowed(true)
            }
        })

        _getPayOutTransacations().catch(e => {

            if (e.status == 403) {

                setShowNotAllowed(true)
            }
        })
        if (ref.current) {

            loadFinancialChartData({ year: 2024 });
        }

    }
    React.useEffect(init, [context.currentBranch, ref.current])

    return (
        <div ref={ref}>

            {/* <Form.Group className="mt-3">
                <Form.Control as="select" value={language} onChange={handleChangeLanguage} style={{ width: 'auto' }}>
                    <option value="pt">🇧🇷</option>
                    <option value="en">🇺🇸</option>
                    <option value="es">🇪🇸</option>
                </Form.Control>
            </Form.Group> */}

            <div className="text-center mt-4">
                <h1 className=' h3'>Módulo Financeiro</h1>

            </div>

            <div className="row mb-2 mt-2">
                <div className='col-6'>
                    <h4 className='text-center'>{international.paymentsIn.screenTexts.received}:</h4>
                    <h4 className='text-center'>{formatCurrencyValue(totalPayInData.received)}</h4>
                </div>
                <div className='col-6'>
                    <h4 className='text-center'>{international.paymentsIn.screenTexts.toReceive}:</h4>
                    <h4 className='text-center'>{formatCurrencyValue(totalPayInData.to_receive)}</h4>
                </div>
            </div>

            <div className="row mb-2 mt-4">
                <div className='col-6'>
                    <h3 className='text-center'>{international.paymentsOut.screenTexts.paid}:</h3>
                    <h4 className='text-center'>{formatCurrencyValue(totalPayOutData.paid)}</h4>
                </div>
                <div className='col-6'>
                    <h3 className='text-center'>{international.paymentsOut.screenTexts.toPay}:</h3>
                    <h4 className='text-center'>{formatCurrencyValue(totalPayOutData.to_pay)}</h4>
                </div>
            </div>





            <div className="row mb-2 mt-2 justify-content-center">

                <Button className="mx-2" onClick={() => window.location.replace('/financial/pay-out')}>Ir para contas a pagar</Button>

                <Button className="mx-2" onClick={() => window.location.replace('/financial/pay-in')}>Ir para contas a receber</Button>

            </div>


            <div className="col-md-6 col-lg-6 ">
                <Text onClick={() => { console.log(financialData) }} as="h3">
                    Receitas e Despesas
                </Text>

                <Bar data={financialData} />

                <div className="mb-3">
                    De:
                    <input
                        type="date"
                        value={startDate}
                        onChange={(e) => {
                            setStartDate(e.target.value)
                            setTimeout(() => {
                                loadFinancialChartData({ start_date: startDate, end_date: endDate }, [`${startDate} - ${endDate}`])
                            }, 1000);
                        }}
                    />
                    Até:
                    <input
                        type="date"
                        value={endDate}
                        onChange={(e) => {
                            setEndDate(e.target.value)
                            setTimeout(() => {
                                loadFinancialChartData({ start_date: startDate, end_date: endDate }, [`${startDate} - ${endDate}`])
                            }, 1000);
                        }}
                    />
                </div>
                <Button className="mx-2" onClick={() => {
                    const today = new Date().toISOString().split('T')[0]
                    loadFinancialChartData({ start_date: today, end_date: today }, ['Hoje'])
                }}>Hoje</Button>

                <Button className="mx-2" onClick={() => {

                    const today = new Date();
                    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1).toISOString().split('T')[0]
                    const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0).toISOString().split('T')[0]
                    // setStartDate();
                    // setEndDate();
                    loadFinancialChartData({ start_date: firstDayOfMonth, end_date: lastDayOfMonth }, ['Mês'])
                }}>Esse Mês</Button>
                <Button className="mx-2" onClick={() => { loadFinancialChartData({ year: new Date().getFullYear() }) }}>Esse Ano</Button>
                <Button className="mx-2" onClick={() => { loadFinancialChartData({ year: new Date().getFullYear() - 1 }) }}>Ano Passado</Button>
            </div>


            <div className="text-center mt-5 pt-3 mb-3">
                <h1 className=' h3'>Últimas Transações</h1>
            </div>

            <div className="pb-4 row  justify-content-around">

                <div >

                    <div className="text-center mb-2">
                        <h3>A Pagar</h3>
                    </div>


                    <TableData
                        tHeadStyle={{ backgroundColor: '#056baa', color: 'white' }}
                        tHeadWhiteText={true}
                        tHead={[
                            "#",
                            "Descrição",
                            "Valor",
                            "Vencimento",
                            "Status",
                        ]}
                        data={lastPayOutTransactions}
                        tBodyKeys={['idx', "description", formatCurrencyValue("value"), "due_date", "status"]}
                    />

                </div>

                <div className="">

                    <div className="text-center mb-2">
                        <h3>A Receber</h3>
                    </div>

                    <TableData
                        tHeadStyle={{ backgroundColor: '#056baa', color: 'white' }}
                        tHeadWhiteText={true}
                        tHead={[
                            "#",
                            "Descrição",
                            "Valor",
                            "Vencimento",
                            "Status",
                        ]}
                        data={lastPayInTransactions}
                        tBodyKeys={['idx', "description", formatCurrencyValue("value"), "due_date", "status"]}
                    />

                </div>

            </div>




            <Dialog onHide={() => { window.location.href = "/" }} show={ShowNotAllowed} type={"info"}>


                <h2>Seu plano não tem acesso a esse módulo, faça um <a href='/plans'>Upgrade de plano</a> para usar. ou <a href="///" onClick={handleClick}>teste gratuitamente</a> por sete dias.</h2>

            </Dialog>

            <Toast {...toast} />

        </div>
    );
};



// WEBPACK FOOTER //
// ./src/views/AppViews/Financial/Home/index.jsx